import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Box
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import Stories from 'react-insta-stories';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { CircleSpinner } from 'react-spinners-kit';
import { useTranslation } from 'react-i18next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Page from '../components/Page';
import { SharePostForm } from '../components/_dashboard/user';
import PostCard from '../components/_dashboard/user/PostCard';
import Modal from '../components/_dashboard/user/Modal';
import PortalModal from '../components/_dashboard/user/PortalModal';
import { Slick } from '../components/_dashboard/user/Slick';
import { CircleStory } from '../components/_dashboard/user/CircleStory';
import Loader from '../components/_dashboard/user/Loader';
import './StoryStyle.css';

const MODAL_STYLES = {
  backgroundColor: 'red',
  borderRadius: 5,
  width: 500,
  margin: '20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'relative'
};
const STORY_STYLES = {};

const useStyles = makeStyles((theme) => ({
  slickCustom: {
    backgroundColor: 'white'
  },
  image: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'red',
    width: '80px',
    height: '80px',
    borderRadius: '100%',
    margin: '0px !important'
  },
  titleStory: {
    width: '100%',
    fontSize: '25px'
  },
  BUTTON_WRAPPER_STYLES: {
    position: 'relative',
    zIndex: 1
  },
  InputPost: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    width: '100%',
    height: '80px',
    borderRadius: '25px',
    cursor: 'pointer',
    padding: '0px 20px',
    marginTop: 20,
    '&:hover': {
      backgroundColor: '#ebe8e8'
    }
  },
  textInputPost: {
    fontSize: '15px',
    color: 'grey'
  }
}));

export default function Actuality() {
  const [t, i18n] = useTranslation();
  const classes = useStyles();
  const navigate = useNavigate();
  const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
  const [data, setData] = useState([]);
  const [dataShare, setDataShare] = useState([]);
  const [dataStory, setDataStory] = useState([]);
  const [storiess, setStoriess] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [openStory, setOpenStory] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [result, setResult] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [oldSlide, setOldSlide] = useState(0);
  const [activeSlide, setActiveSlide] = useState(0);
  const [activeSlide2, setActiveSlide2] = useState(0);

  const handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop ===
        document.scrollingElement.scrollHeight ||
      isFetching
    )
      return;
    setIsFetching(true);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isFetching && result.next != null) {
      loadMoreActuality();
    }
  }, [isFetching]);

  const StoryData = (item) => {
    const FormatData = [];
    for (let i = 0; i < item.story.length; i += 1) {
      FormatData.push({
        url: `${API_ENDPOINT}${item.story[i].media}`,
        header: {
          heading: (
            <div style={{ display: 'flex', alignItems: 'center', margin: '0px 5px' }}>
              <p style={{ flex: 1 }}>{item.created_by_name}</p>
              <IconButton
                size="small"
                aria-label={t('upload picture')}
                component="span"
                onClick={() => setOpenStory(false)}
                style={{ marginLeft: 170 }}
              >
                <CloseIcon style={{ color: 'white' }} />
              </IconButton>
            </div>
          ),
          profileImage: `${API_ENDPOINT}${item.created_by_photo}`
        }
      });
    }
    setStoriess(FormatData);
    console.log('//////stories-->', storiess);
    return storiess;
  };

  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <button
        className={className}
        style={{
          ...style,
          display: 'block',
          backgroundColor: 'white',
          color: 'grey',
          position: 'absolute',
          top: 30,
          left: -50
        }}
        onClick={onClick}
      >
        <ArrowBackIosNewIcon style={{ color: 'grey' }} />
      </button>
    );
  };

  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <button
        className={className}
        style={{
          ...style,
          display: 'block',
          color: 'grey',
          position: 'absolute',
          top: 30,
          right: -50
        }}
        onClick={onClick}
      >
        <ArrowForwardIosIcon style={{ color: 'grey' }} />
      </button>
    );
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: true,
    rtl: false,
    beforeChange: (current, next) => {
      setOldSlide(current);
      setActiveSlide(next);
    },
    afterChange: (current) => setActiveSlide2(current)
  };

  const toggleModal = (data) => {
    setIsOpen(!isOpen);
    setDataShare(data);
    console.log('bbbbbbbbbbbb', dataShare);
  };

  const StoryModal = () => {
    setOpenStory(!openStory);
  };

  // GET STORY
  const GetStory = () => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    axios
      .get(`${API_ENDPOINT}/api/create-story/`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((response) => {
        console.log('get stooory -->', response.data);
        setDataStory(response.data);
      })
      .catch((err) => {
        console.log('err stooory', err);
      });
    return dataStory;
  };

  // LIKE FUNTION
  const likeOrDislike = (pk) => {
    const data = { pk_post: pk };
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    axios
      .post(`${API_ENDPOINT}/api/like-post-from-actuality/`, data, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((response) => {
        console.log('response -->', response.data);
      });
  };

  // GET all actuality
  const retrieveActuality = () => {
    setIsLoading(true);
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    axios
      .get(`${API_ENDPOINT}/api/create-actuality/`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((response) => {
        setIsLoading(false);
        console.log('get -->', response.data);
        setData(response.data.results);
        setResult(response.data);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  useEffect(() => {
    retrieveActuality();
  }, []);

  // LOAD MORE ACTUALITY
  const loadMoreActuality = () => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    axios
      .get(`${result.next}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((response) => {
        console.log('get -->', response.data);
        setResult(response.data);
        setData((oldData) => [...oldData, ...response.data.results]);
        setIsFetching(false);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  useEffect(() => {
    GetStory();
  }, []);

  return (
    <Page title={t('actualité')}>
      <Container style={{ backgroundColor: 'white', width: '80%' }}>
        <Loader load={isLoading} />
        <Stack direction="column" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t('actualité')}
          </Typography>
          <Box onClick={() => navigate('/dashboard/add_post')} className={classes.InputPost}>
            <Typography align="left" variant="body2" className={classes.textInputPost}>
              {t('Ajouterpublication')}...
            </Typography>
          </Box>
        </Stack>
        <Stack direction="column" spacing={3} alignItems="center" mb={5}>
          <Typography align="left" variant="h3" className={classes.titleStory}>
            {t('Stories')}
          </Typography>
          <div style={{ width: '100%', backgroundColor: 'grey' }}>
            <Slick rtl settings={settings}>
              {dataStory !== null &&
                dataStory.map((row) => (
                  <div className={classes.slickCustom}>
                    <CircleStory
                      baseImage={`${API_ENDPOINT}${row.created_by_photo}`}
                      username={row.created_by_name}
                      handleClick={() => {
                        StoryData(row);
                        setOpenStory(!openStory);
                      }}
                    />
                  </div>
                ))}
            </Slick>
          </div>
          {data.map((row) => (
            <PostCard
              row={row}
              likeFunction={likeOrDislike}
              shareFunction={() => toggleModal(row)}
              data={data}
              setData={setData}
            />
          ))}
          {isFetching && result.next != null && (
            <Box display="flex" justifyContent="center" sx={{ p: 3 }}>
              <CircleSpinner size={30} color="#ec8181" loading={isFetching} />
            </Box>
          )}
        </Stack>
        <Modal show={isOpen} onClose={toggleModal}>
          <Typography
            align="left"
            style={{ width: '100%', color: '#EC8B8B' }}
            variant="h4"
            gutterBottom
          >
            {t('partagerlapublication')}
          </Typography>
          <SharePostForm row={dataShare} cancel={toggleModal} />
        </Modal>
        <PortalModal open={openStory}>
          <Stories
            stories={storiess}
            onAllStoriesEnd={() => setOpenStory(false)}
            keyboardNavigation
          />
        </PortalModal>
      </Container>
    </Page>
  );
}

/*
  <Box style={{ width: '100%', backgroundColor: 'grey' }}>
            <Slick settings={settings}>
              {dataStory !== null &&
                dataStory.map((row) => (
                  <div className={classes.slickCustom}>
                    <CircleStory
                      baseImage={`${API_ENDPOINT}${row.created_by_photo}`}
                      username={row.created_by_name}
                      handleClick={() => console.log('click st')}
                    />
                  </div>
                ))}
            </Slick>
          </Box>
*/
